import { render, staticRenderFns } from "./comp2.vue?vue&type=template&id=62985caa&scoped=true"
import script from "./comp2.vue?vue&type=script&lang=ts"
export * from "./comp2.vue?vue&type=script&lang=ts"
import style0 from "./comp2.vue?vue&type=style&index=0&id=62985caa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62985caa",
  null
  
)

export default component.exports